<div class="col-sm-12 col-md-8 mt-3">
    <div class="calendar" *ngIf="availableDays">
        <div class="inner-div">
            <mat-calendar #calendar [selected]="selectedDate" [startAt]="startDate" [minDate]="minDate"
                [maxDate]="maxDate" (selectedChange)="newUpdateSlots($event)" [dateFilter]="unavailableDates">
            </mat-calendar>
            <div class="availability-markers">
                <span class="available"></span><span class="mr-4">Available</span>
                <span class="unavailable"></span><span class="mr-4">Fully booked / Not yet released</span>
                <span class="selected"></span><span>Selected</span>
            </div>
        </div>
    </div>
</div>

<div class="col-sm-12 col-md-4 mt-3">
    <div class="row">
        <div class="text-center col-sm-12">
            <h4 tabindex="0" attr.aria-label="selected date, {{selectedDate | date : 'EEEE d MMMM'}}">
                {{selectedDate | date : 'EEEE d MMMM'}}</h4>
            <hr />
            <span *ngIf="slots?.length == 0" tabindex="0">There are no slots available</span>
        </div>

        <div *ngFor="let slot of slots" class="col-4 col-sm-4 col-md-6">
            <button class="slot-btn" (click)="selectSlot(slot)"
                [ngClass]="{'selected-slot-btn': selectedSlot?.start === slot?.start}">{{slot?.start | date:
                'HH:mm' }}</button>
        </div>
    </div>
</div>


<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="rgb(50, 125, 156)" type="ball-scale-multiple">
    <p style="font-size: 20px; color: #fff">{{ 'COMMON.LOADING' | translate}}</p>
  </ngx-spinner>
